import { Box, Button, Typography } from "@mui/material";
import JoditEditor from "jodit-react";
import React, { useRef, useState } from "react";
import UpdateBid from "./UpdateBid";
import "./postbid-modern.css";

function PostBidDescriptionUpdate({ bidData }) {
  const ref = useRef(null);
  const [next, setNext] = useState(false);
  const [data, setData] = useState(bidData.description || "");
  const [validDesc, setValidDesc] = useState(false);
  const editorConfig = {
    readonly: false, toolbar: true, spellcheck: true, language: "en", toolbarButtonSize: "small", toolbarAdaptive: false,
    showCharsCounter: true, showWordsCounter: true, showXPathInStatusbar: false, askBeforePasteHTML: true, askBeforePasteFromWord: true,
    uploader: { insertImageAsBase64URI: true },
  };

  const handleSubmit = () => {
    const plainText = data.replace(/<[^>]*>/g, "").trim();
    if (plainText.length < 20) { setValidDesc(true); return; }
    setValidDesc(false);
    bidData.description = data;
    // Keep any existing notes for old tenders, but do not ask the user to maintain a redundant field.
    if (bidData.notes == null) bidData.notes = "";
    setNext(true);
  };

  return (
    <Box className="bidit-postbid-step" sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}>
      {!next ? (
        <Box className="bidit-form-card">
          <Box className="bidit-form-intro">
            <Box className="bidit-form-intro-badge"><span className="bidit-form-intro-spark">✦</span>שלב אחרון</Box>
            <Typography variant="h6" className="bidit-form-title" sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}>עדכון תיאור העבודה</Typography>
            <Typography className="bidit-form-subtitle" sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}>עברו על התיאור ושמרו את המכרז מחדש</Typography>
          </Box>
          <JoditEditor
            value={data}
            ref={ref}
            config={editorConfig}
            onChange={(newContent) => setData(newContent)}
            onBlur={(newContent) => setData(newContent)}
          />
          {validDesc && <Box className="bidit-inline-error">התיאור צריך להיות לפחות 20 תווים</Box>}
          <Button className="bidit-primary-button" sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, mt: 3, width: "100%" }} variant="contained" onClick={handleSubmit}>
            שמירה ופרסום מחדש
          </Button>
        </Box>
      ) : <UpdateBid bidData={bidData} />}
    </Box>
  );
}
export default PostBidDescriptionUpdate;
